define([
	"dojo/_base/declare",
	"csi/heading/Property",
	"csi/locale"
], function(declare,Property,locale) {

	return declare(Property, {
		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return name using display format
			return locale.getNodeConfiguredName(ctx.getNode(), ctx.cache, ctx.locale);
		},

		_toFilterValue: function(/*Context*/ctx, /*Heading*/h, /*Any*/value) {
			// summary: return value to be used in query when sorting/filtering by heading
			return locale.getNodeStoredName(ctx.getNode(), ctx.cache, ctx.locale);
		}
	});
});